document.addEventListener("turbo:load", function() {
  // Jeder .press-Block bekommt seinen eigenen Slider (Pressebereich,
  // "Hired by", Workship). Die Initialisierung lief vorher über die ID
  // #press__slider – sobald zwei Blöcke auf einer Seite stehen, wurde nur der
  // erste initialisiert und die Pfeil-Selektoren griffen quer über beide.
  $('.press').each(function() {
    initPressSlider(this);
  });

  function initPressSlider(section) {
    var $section = $(section);
    var $slider = $section.find('.press__slider');

    if (!$slider.length) return;

    $slider.slick({
      mobileFirst: true,
      prevArrow: $section.find('.press__prevArrow'),
      nextArrow: $section.find('.press__nextArrow'),
      slidesToShow: 2,
      responsive: [
        {
          breakpoint: 479,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 4
          }
        }
      ]
    });

    // set same height for each slide
    setSlideHeight($slider);

    // set same height for each slide after position/size changes
    $slider.on('setPosition', function () {
      setSlideHeight(this);
    });

    // Die Logos laden lazy und sind beim ersten Seitenaufruf noch 0px hoch,
    // wenn setSlideHeight misst – die Slides würden auf diese Höhe
    // eingefroren. Deshalb nach jedem geladenen Bild neu berechnen.
    $slider.find('img').on('load', function () {
      setSlideHeight($slider);
    });
  }

  function setSlideHeight(slider) {
    $(slider).find('.slick-slide').height('auto');
    var slickTrack = $(slider).find('.slick-track');
    var slickTrackHeight = $(slickTrack).height();
    $(slider).find('.slick-slide').css('height', slickTrackHeight + 'px');
  };
});
